import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Stack } from '@mantine/core';

import { useGetOrganisation } from 'api/organisations';
import { LogoSettings } from './LogoSettings';
import { NameSettings } from './NameSettings';

export const GeneralSettings = () => {
  const { organisationId } = useParams();
  if (!organisationId) throw new Error('Organisation ID is required');
  const { data: organisation } = useGetOrganisation({
    pathParams: { organisationId },
  });

  const hasEmailCustomizationAccess = useMemo(
    () =>
      organisation
        ? organisation.__links.find(
            link => link.rel === 'email_customization',
          ) !== undefined
        : undefined,
    [organisation],
  );

  if (!organisation) return null;

  return (
    <Stack spacing="xl">
      {hasEmailCustomizationAccess && (
        <LogoSettings organisation={organisation} />
      )}
      <NameSettings organisation={organisation} />
    </Stack>
  );
};
